import React, {useMemo} from 'react';
import {t} from 'i18next';
import dayjs from 'dayjs';
import styled from 'styled-components';
import ConfirmationModal from '../ConfirmationModal';
import {FlexColumnSection, FlexRowSection, SmallText} from '../../../styles/globalStyles';
import {Colors} from '@arboxappv4/shared/src/styles/Colors';
import {DB_DATE_FORMAT} from '@arboxappv4/shared/src/constants/constants';

const LinkExistingMemberModal = (props) => {
    const {isOpen, onClose, onConfirm, candidate} = props;

    const header = useMemo(() => {
        if (!candidate) return '';
        return `${candidate.first_name || ''} ${candidate.last_name || ''}`.trim();
    }, [candidate]);

    const genderLabel = useMemo(() => {
        if (!candidate?.gender) return '-';
        return t(candidate.gender) || candidate.gender;
    }, [candidate?.gender]);

    const birthdayLabel = useMemo(() => {
        if (!candidate?.birthday) return '-';
        const parsed = dayjs(candidate.birthday, DB_DATE_FORMAT);
        return parsed.isValid() ? parsed.format('DD/MM/YYYY') : candidate.birthday;
    }, [candidate?.birthday]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            header={header}
            explanation={t('personal-id-link-group-popup-explain')}
            submitText={t('proceed')}
            content={
                <FlexColumnSection gap={'12px'}>
                    <DetailRow label={t('personal-id')} value={candidate?.personal_id || '-'} />
                    <DetailRow label={t('gender')} value={genderLabel} />
                    <DetailRow label={t('birth-date')} value={birthdayLabel} />
                </FlexColumnSection>
            }
        />
    );
};

const DetailRow = ({label, value}) => (
    <FlexRowSection justify={'space-between'} gap={'12px'}>
        <DetailLabel>{label}</DetailLabel>
        <DetailValue>{value}</DetailValue>
    </FlexRowSection>
);

export default LinkExistingMemberModal;

const DetailLabel = styled(SmallText)`
    color: ${Colors.siteBlack};
    opacity: 0.7;
`;

const DetailValue = styled(SmallText)`
    font-weight: 600;
    color: ${Colors.siteBlack};
`;
